import { render, staticRenderFns } from "./PanelNoveltyBoxes.vue?vue&type=template&id=ec3c3532&"
import script from "./PanelNoveltyBoxes.vue?vue&type=script&lang=js&"
export * from "./PanelNoveltyBoxes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports